import { Box, useTheme } from '@mui/material'
import { useGetProductsWithComponentsInMooring } from 'src/api/components'
import { CenteredSpinner } from 'src/components/Spinner'
import { IComponentFilters } from 'src/generated-types'
import ProductDetailAccordion from './ProductDetailAccordion'

interface IProductDetailAccordionProps {
  customerId: EntityId
  localityId: EntityId
  mooringId: EntityId
  localityName?: string
  filters: IComponentFilters
}
const ProductListContainer: React.FC<IProductDetailAccordionProps> = ({
  customerId,
  localityId,
  mooringId,
  localityName,
  filters,
}) => {
  const theme = useTheme()
  const { data: productsWithComponents, isLoading } = useGetProductsWithComponentsInMooring(
    customerId,
    localityId,
    mooringId,
    filters,
  )
  return (
    <>
      {isLoading ? (
        <CenteredSpinner size={'50px'} height={100} />
      ) : (
        productsWithComponents &&
        productsWithComponents.length > 0 &&
        productsWithComponents.map(product => (
          <Box borderBottom={`1px solid ${theme.palette.gray.main}`} key={product.productId}>
            <ProductDetailAccordion
              customerId={customerId}
              localityId={localityId}
              mooringId={mooringId}
              localityName={localityName}
              product={product}
              filters={filters}
            />
          </Box>
        ))
      )}
    </>
  )
}

export default ProductListContainer
